<div class="container-fluid">
    <div class="row table-header fw-bold py-2 mt-2">
        <div class="col-1"></div>
        @for (column of model.tableModel.options.columns; track column) {
            <div class="col-lg-3 col-5">{{ column.title }}</div>
        }
    </div>
    @for (row of model.tableModel.rows; track row; let i = $index) {
        <pace-pi-spare-part-expandable
            [parentForm]="formChildren"
            [row]="row"
            [columns]="model.tableModel.options.columns"
            (deleteRow)="deleteMaterial(i)"
            (quantityChange)="validateRowWithIndex(i, $event)"
        >
        </pace-pi-spare-part-expandable>
    }
</div>

<div class="row mt-3">
    <div class="col-12">
        <button
            class="btn btn-primary float-end"
            type="button"
            [translate]="'PHYSICAL_INVENTORY_ADD_NEW_ENTRY_LABEL'"
            (click)="addMaterial()"
        ></button>
    </div>
</div>
